/**
 * A fixed-price sale's time limit (`R-LOT-34`), the panel's half.
 *
 * The bounds are the server's — `SELL_SECONDS_MIN` and `SELL_SECONDS_MAX` in
 * `packages/core/src/shows/lots.ts`, and the `lot_sell_seconds` constraint behind them — repeated
 * so the form can refuse before sending. The route refuses again either way.
 */
export const SELL_SECONDS_MIN = 5;
export const SELL_SECONDS_MAX = 30 * 60;

/** The input's value: whole seconds, or `""` for no limit. */
export type SellInput = number | "";

/** What to send: seconds, or null for no limit. */
export function sellSecondsOf(value: SellInput): number | null {
  return value === "" ? null : value;
}

/** True when the input holds something the server would refuse. */
export function sellSecondsInvalid(value: SellInput): boolean {
  return (
    value !== "" &&
    (!Number.isInteger(value) || value < SELL_SECONDS_MIN || value > SELL_SECONDS_MAX)
  );
}

/** Whole seconds left until `closesAt`, never below zero. */
export function secondsUntil(closesAt: string, now: number): number {
  return Math.max(0, Math.ceil((Date.parse(closesAt) - now) / 1000));
}
